module.exports = __webpack_public_path__ + "static/media/wallet-card.3f4351c9.svg";